import React from 'react';
import { ExecSummarySlide } from './slides/ExecSummarySlide';
export function Presentation() {
  return <div className="relative w-full h-full overflow-hidden bg-brand-dark text-white" data-id="element-10">
      <ExecSummarySlide data-id="element-11" />
    </div>;
}